<template>
    <div :class="wrapperClasses" :style="wrapperStyles">
        <div class="label-desc">
            <div class="label" :for="name" v-if="label" :style="labelStyles">
                <span class="inner">{{ label }}</span>
                <span class="required" v-if="required">*</span>
            </div>
            <i
                class="extra-info far fa-question-circle"
                v-if="extraInfo"
                @click="$emit('extra-info-click')"
                :style="extraInfoStyles"
            />
            <div class="description" v-if="description">{{ description }}</div>
        </div>
        <select
            :class="selectClass"
            :ref="name"
            :name="name"
            :id="id"
            :style="selectStyles"
            :disabled="disabled"
            :value="value"
            @change="
                $emit('input', $event.target.value);
                $emit('change', $event.target.value);
            "
        >
            <slot></slot>
        </select>
    </div>
</template>

<script>
    import Autofocus from '../mixins/Autofocus.vue';
    import FormControl from '../mixins/FormControl.vue';

    export default {
        name: 'FormSelect',
        data() {
            return {
                type: 'FormSelect',
            };
        },
        props: {
            selectClass: {
                type: String,
                default: '',
            },
        },
        mixins: [Autofocus, FormControl],
        methods: {},
    };
</script>

<style lang="scss" scoped>
    @import '../scss/formControl';

    select {
        @include box-shadow-small;
        @include select;

        font-size: 100%;
        width: 100%;
        flex-shrink: 0;
        padding-left: $padding-left;
    }

    .control-wrapper.horizontal .label {
        padding-left: 0;
    }
</style>